import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BehaviorService } from '../_services/behavior.service';

@Injectable({
  providedIn: 'root'
})
export class BuyGuard implements CanActivate {

  private buyInfo$: any;

  constructor(
    private beh: BehaviorService,
    private router: Router
  ) {
    this.beh.voucherData.subscribe(val => { this.buyInfo$ = val });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    (!this.buyInfo$ || !this.buyInfo$.selected || !this.buyInfo$.voucher) && this.router.navigate(['voucher', route.params.voucherId]);
    return !!this.buyInfo$?.selected && !!this.buyInfo$.voucher ? true : false;
  }

}
